import { useTranslation } from "react-i18next";
import { Form, Modal, Select, Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import "./list-question-bank-modal.scss";
import { getAllQuestionBankCanEdit } from "../../../../../service/library";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { useForm, useWatch } from "antd/es/form/Form";

type ListQuestionBankModalProps = {
  mode: string;
  isOpenModal: boolean;
  moveLoading: boolean;
  setBankId?: (value: number) => void;
  setIsOpenModal: (value: boolean) => void;
  hanldeMoveQuizToQuestionBank: (value: number) => void;
};

const ListQuestionBankModal = ({
  mode,
  isOpenModal,
  moveLoading,
  setBankId,
  setIsOpenModal,
  hanldeMoveQuizToQuestionBank,
}: ListQuestionBankModalProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [questionBankId, setQuestionBankId] = useState<number>(0);
  const [questionBankList, setQuestionBankList] = useState<any>([]);

  const getSelectedBankValue = Form.useWatch("questionBank", form);

  const handleOk = () => {
    hanldeMoveQuizToQuestionBank(questionBankId);
  };

  const handleCancel = () => {
    setIsOpenModal(false);
  };

  const getAllQuestionBank = async () => {
    setIsLoading(true);
    try {
      const res = await getAllQuestionBankCanEdit({});
      if (res.status === 200) {
        setQuestionBankList(res.data.data?.content);
        setIsLoading(false);
      }
    } catch (error) {
      console.error();
    } finally {
      setIsLoading(false);
    }
  };

  const renderTitle = (mode: string) => {
    switch (mode) {
      case "move":
        return "Chọn ngân hàng để di chuyển câu hỏi"
      case "duplicate":
        return "Chọn ngân hàng để tạo bản sao"
      default:
        break;
    }
  }

  // useEffect
  useEffect(() => {
    if (isOpenModal) {
      getAllQuestionBank();
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (questionBankList.length > 0) {
      form.setFieldValue("questionBank", questionBankList[0]?.id);
      setQuestionBankId(questionBankList[0]?.id);
      setBankId && setBankId(questionBankList[0]?.id);
    }
  }, [questionBankList]);

  return (
    <Modal
      title={renderTitle(mode)}
      open={isOpenModal}
      onOk={() => handleOk()}
      onCancel={handleCancel}
      okText={
        moveLoading ? (
          <>
            {t("Xác nhận", "Xác nhận")} <Spin className="ml-1" size="small" />
          </>
        ) : (
          "Xác nhận"
        )
      }
      cancelText={t("Hủy", "Hủy")}
      okButtonProps={{ disabled: moveLoading || !getSelectedBankValue }}
      cancelButtonProps={{ disabled: moveLoading }}
      maskClosable={false}
      closable={!moveLoading}
      className="list-question-bank-to-move-modal"
    >
      <Typography.Text>{t("Ngân hàng", "Ngân hàng")}</Typography.Text>
      <Form form={form}>
        {!isLoading ? (
          <Form.Item name="questionBank" className="question-bank-form-item">
            <FormItemDropdown
              className="ml-2"
              options={questionBankList}
              onChange={(e) => {setQuestionBankId(e); (setBankId && setBankId(e))}}
              style={{ minWidth: 300, maxWidth: "80%" }}
              disabled={moveLoading}
            />
          </Form.Item>
        ) : <Spin className="ml-3" size="default"/>}
      </Form>
    </Modal>
  );
};

export default ListQuestionBankModal;
